// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3FLG7","content":"styles_content__uXhaP","checkbox":"styles_checkbox__KAZOr","checkboxLabel":"styles_checkboxLabel__1hj3c"};